import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import QuestionFormBase from './QuestionFormBase';
import { getQuestionById, updateQuestion } from '../../../services/questionAPIService';
import StandardLayout from '../../../components/layout/StandardLayout';
import { XMarkIcon } from '@heroicons/react/24/outline';

const QuestionEditForm = () => {
    const { id } = useParams();
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadQuestionData = useCallback(async () => {
        try {
            const data = await getQuestionById(id);
            // Transform the data to include image URLs
            const transformedData = {
                ...data,
                question_image: data.question_image || null,
                answer_image: data.answer_image || null,
                explanation_image: data.explanation_image || null,
            };
            setInitialData(transformedData);
            setError(null);
        } catch (err) {
            setError('Fehler beim Laden der Frage');
            console.error('Error loading question:', err);
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        loadQuestionData();
    }, [loadQuestionData]);

    const handleSubmit = async (formData) => {
        try {
            await updateQuestion(id, formData);
        } catch (error) {
            console.error('Error updating question:', error);
            throw error;
        }
    };

    if (loading) {
        return (
            <StandardLayout>
                <div className="flex justify-center items-center min-h-screen">
                    <span className="loading loading-spinner loading-lg text-primary"></span>
                </div>
            </StandardLayout>
        );
    }

    if (error) {
        return (
            <StandardLayout>
                <div className="container mx-auto px-4 py-8">
                    <div className="alert alert-error">
                        <XMarkIcon className="w-6 h-6" />
                        <span>{error}</span>
                    </div>
                </div>
            </StandardLayout>
        );
    }

    if (!initialData) {
        return (
            <StandardLayout>
                <div className="container mx-auto px-4 py-8">
                    <div className="alert alert-error">
                        <XMarkIcon className="w-6 h-6" />
                        <span>Frage nicht gefunden</span>
                    </div>
                </div>
            </StandardLayout>
        );
    }

    return (
        <QuestionFormBase
            initialData={initialData}
            onSubmit={handleSubmit}
            submitButtonText="Frage aktualisieren"
            title="Frage bearbeiten"
            isEdit={true}
        />
    );
};

export default QuestionEditForm; 